import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useRouteLoading = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    window.scrollTo(0, 0);

    const timer = setTimeout(() => setLoading(false), 500);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return loading;
};

export default useRouteLoading;
